import React, { useState } from 'react';
import BlurText from './BlurText';

const EnterpriseSolutions = () => {
  const [limitationsEnabled, setLimitationsEnabled] = useState(false);

  const members = [
    { username: 'Smith', email: 'john.smith@mail.com', role: 'Admin', status: 'active' },
    { username: 'Smith', email: 'john.smith@mail.com', role: 'Member', status: 'disabled' },
    { username: 'Smith', email: 'john.smith@mail.com', role: '—', status: 'invited', faded: true }
  ];

  const uptimeBars = Array(20).fill(null);

  return (
    <section className="enterprise-solutions">
      <div className="container">
        <h2 className="enterprise-title">
          <BlurText text="Enterprise Solutions to Everyday Proxy Challenges" delay={62} direction="top" />
        </h2>

        <div className="enterprise-feature">
          <div className="enterprise-left">
            <div className="members-panel">
              <div className="organization-header">
                <span className="org-dot"></span>
                <span>Organization A</span>
              </div>
              <div className="members-section">
                <h4>LIST OF MEMBERS</h4>
                <table className="members-table">
                  <thead>
                    <tr>
                      <th>Username</th>
                      <th>Email address</th>
                      <th>Role</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {members.map((member, index) => (
                      <tr key={index} className={member.faded ? 'faded' : ''}>
                        <td>{member.username}</td>
                        <td>{member.email}</td>
                        <td>{member.role}</td>
                        <td>
                          <span className={`status-badge ${member.status}`}>
                            {member.status.charAt(0).toUpperCase() + member.status.slice(1)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="usage-limits">
                <h4>SET DATA USAGE LIMITS</h4>
                <div className="toggle-container">
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={limitationsEnabled}
                      onChange={(e) => setLimitationsEnabled(e.target.checked)}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                  <span>Enable Limitations</span>
                </div>
              </div>
            </div>
          </div>
          <div className="enterprise-right">
            <div className="enterprise-icon-badge">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect x="6" y="8" width="12" height="2" fill="#E8FF00"/>
                <rect x="6" y="12" width="12" height="2" fill="#E8FF00"/>
                <rect x="6" y="16" width="12" height="2" fill="#E8FF00"/>
              </svg>
            </div>
            <h3>Scalable Control & Insights</h3>
            <p>
              Take full control of your proxy usage with real-time analytics, project-based tracking,
              and granular team permissions. Easily monitor bandwidth, set limits, and manage access
              from one centralized dashboard.
            </p>
          </div>
        </div>

        <div className="enterprise-feature reverse">
          <div className="enterprise-left">
            <div className="enterprise-icon-badge">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect x="6" y="8" width="12" height="2" fill="#E8FF00"/>
                <rect x="6" y="12" width="12" height="2" fill="#E8FF00"/>
                <rect x="6" y="16" width="12" height="2" fill="#E8FF00"/>
              </svg>
            </div>
            <h3>Enterprise-Grade Uptime</h3>
            <p>
              Run high-volume scraping, testing, and automation without interruptions. Built-in redundancy
              and zero third-party dependencies ensure 99.9% uptime for all your projects.
            </p>
          </div>
          <div className="enterprise-right">
            <div className="uptime-panel">
              <div className="panel-header">
                <div className="brand-logo">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2L15 8L12 14L9 8L12 2Z" fill="#E8FF00"/>
                  </svg>
                  <span>pathproxy</span>
                </div>
                <span className="service-status-link">Service status</span>
              </div>
              <div className="uptime-status-box">
                <div className="status-header">
                  <span className="status-dot-large"></span>
                  <span className="status-text">All systems <span className="operational">operational</span></span>
                </div>
                <div className="uptime-chart">
                  <div className="chart-label">
                    <span>pathproxy Uptime</span>
                    <span>Last 90 Days</span>
                  </div>
                  <div className="chart-bars">
                    {uptimeBars.map((_, index) => (
                      <div className="bar" key={index}></div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseSolutions;
